module.exports = __webpack_public_path__ + "img/7.469b24f1.png";